import React, { PureComponent } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import { enCurrency, enLang } from 'interfaces/IProductData';

export interface IProps {
  option: {
    lang: enLang;
    currency: enCurrency;
    symbol: string;
  };
  selected: boolean;
  onSelect: (currency: enCurrency) => void;
}

export default class CurrencyItem extends PureComponent<IProps> {

  onSelect = () => {
    this.props.onSelect(this.props.option.currency);
  }

  render() {

    const { option } = this.props;

    return (
      <MenuItem
        selected={this.props.selected}
        onClick={this.onSelect}
      >
        <div className='currency-menu-item'>
          <span className='symbol'>{option.symbol}</span><span className='currency'>{option.currency}</span>
        </div>
      </MenuItem>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/ConfigCurrency/CurrencyItem.tsx